export default __webpack_public_path__ + "static/media/icon_comment_none.3a702fad.svg";